import styled from "styled-components";




export const ChallengesContainer = styled.div`
  width: 100%;
  ${'' /* padding: 0 25px; */}
  width: 100%;
  max-width: 1248px;
  margin: auto;
  padding-top: 25px;
  ${'' /* > div {
    width: 100%;
    max-width: 1248px;
    margin: auto;
    padding-top: 25px;
  } */}
`;


export const WeekWrapper = styled.div`
.dayText{
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  ${'' /* font-size: 14px; */}
  font-size:${({isDayText})=> isDayText ? isDayText : '14px'};
  font-style: normal;
  font-weight: ${({isDayWeight})=> isDayWeight ? isDayWeight : '700'};
  ${'' /* font-weight: 700; */}
  line-height: 20px; 
    margin-bottom: 8px;
}
`;





export const WeekContainer = styled.div`

display:flex;
justify-content: space-between;
.weeekText{
color:  #184A61;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px;
}
`;


export const OptionsContainer = styled.div`


.questionsText{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #F8F8F8;
  border-radius: 50%;
  font-weight: bold;
  font-size: 14px;
  color: #184A61;
  flex-shrink: 0;


  ${'' /* display: flex;
  width: 40px;
  height: 40px;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: var(--Bg-Color-for-Light-theme-500, #F8F8F8); */}

.questionsNumber{
  width: 12px;
  height: 24px;
  flex-shrink: 0;
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  text-align: center;
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; 
}
}
`;



export const AudioFileContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 0.75px solid #DCDCDC;
  border-radius: 4px;
  background-color: #FAFAFA;
  margin-bottom: 15px;
  width: 290px;
`;

export const AudioUploadBox = styled.div`
  border: 0.75px solid #DCDCDC;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: background-color 0.2s;
  height: 182px;
  margin-bottom: 8px;
  width: 290px;
  ${'' /* &:hover {
    background-color: #F0F0F0;
  } */}

  input {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
  }
`;

export const FileName = styled.div`
  color: #184A61;
  font-size: 14px;
  font-family: 'Lato', sans-serif;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
`;

export const CloseIconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: color 0.2s;

  &:hover {
    color: #DA6C74;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;



export const MoreOptionText = styled.div`
 display:flex;
 align-items:center;
 gap:12px;
 cursor:pointer;
 margin:${({isMargin})=> isMargin ? isMargin : '8px 0px'};

 .icon{
  width:32px;
  height:32px;
  display:flex;
  align-items:center;
  justify-content: center;
 }

.addOptionsText{
  color:  #184A61;
  font-family: Lato;
  align-items:center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
 
}
`;



export const ToggleWrapper = styled.div`
  display: flex;
  width: 40px;
  height: 24px;
  padding: 2px;
  align-items: center;
  border-radius: 12px;
  border: 1px solid  #EFEFEF;
  background: ${(props) =>
    props.active
      ? " #DA6C74"
      : " #EFEFEF"};
  cursor: pointer;
  transition: background 0.3s ease-in-out;
`;

export const ToggleCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
 
  background: ${({ active }) =>
    active
      ? "#FFFFFF"
      :  "#BDBDBD"};
  flex-shrink: 0;
  transition: transform 0.3s ease-in-out;
  transform: ${(props) => (props.active ? "translateX(16px)" : "translateX(0)")};
`;


export const ToggleContainer = styled.div`
    display: flex;
    gap:12px;
    width:100%;
    justify-content: flex-end;

    .respondsText{
       color:  #184A61;
       font-family: Lato;
       font-size: 16px;
       font-style: normal;
       font-weight: 400;
       line-height: 20px; 
    }
`;



export const ActionButton = styled.div`
    display: flex;
    width:200px;
    height: 40px;
    margin-top:20px;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    flex: 1;
    ${'' /* max-width: calc(50% - 8px);  */}
    border:${({isBorderColor})=> isBorderColor ? isBorderColor : '1px solid #Da6C74'};
    ${'' /* border: 1px solid #F37A65; */}
    border-radius: 4px;
    background: transparent;
    color: #184A61;
    font-family: 'Lato';
    font-size: 16px;
    font-style: normal;
    font-weight: 400; 
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; 
    cursor: pointer;
    box-sizing: border-box;
`;

